import { db } from '@/main.js'

export default {
  props: ['user', 'profile'],
  data() {
    let item = undefined
    if (this.$route && this.$route.params.from_item) {
      item = this.$route.params.from_item
    }

    return {
      param: 'id',
      params: {},
      items: [],
      item: item,
      is_saving: false,
      page_size: 20,
      page_size_options: [20, 50, 100],
      current_page: 0,
      previous_page_loading: false,
      next_page_loading: false,
      no_more_results: false
    }
  },
  methods: {
    view_row(item) {
      this.$router.push({name: this.collection, params: {id: item.id, from_item: item}})
    },
    view_row_new_tab(item) {
      let routeData = this.$router.resolve({name: this.collection, params: {id: item.id}})
      window.open(routeData.href, '_blank')
    },
    validate_state(name) {
      const { $dirty, $error } = this.$v.item[name];
      return $dirty ? !$error : null;
    },
    async edit_item() {
      this.$v.item.$touch()
      if (this.$v.item.$anyError) {
        return
      }

      this.item.updated = new Date()

      this.is_saving = true
      if (this.do_before) {
        let success = await this.do_before()
        if (success === false) {
          this.is_saving = false
          return
        }
      }

      if (this.item.team) {delete this.item.team}
      if (this.item.user) {delete this.item.user}
      if (this.item.current_period) {delete this.item.current_period}
      if (this.item.voice_doc && this.item.voice_doc.name) {delete this.item.voice_doc}
      if (this.item.sender) {delete this.item.sender}
      if (this.item.steps) {delete this.item.steps}
      if (this.item.recipient) {delete this.item.recipient}

      await this.$firestoreRefs.item.update(this.item)
      if (this.do_after) {
        await this.do_after()
      }
      this.is_saving = false

      if (this.navigate_to) {
        this.navigate_to(this.item.id)
      } else {
        let params = this.params
        params[this.param] = this.item.id
        this.$router.push({name: this.collection, params: params})
      }

      this.$bvToast.toast(`Data has been saved`, {title: 'Saved', autoHideDelay: 2000, variant: 'success'})
    },
    async delete_item() {
      let result = await this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      })

      if (!result.value) {
        return
      }

      if (this.do_before) {
        await this.do_before()
      }
      // await this.$firestoreRefs.item.delete()
      this.$firestoreRefs.item.update({status: 'deleted', updated: new Date()})
      if (this.do_after) {
        await this.do_after()
      }

      if (this.navigate_to_delete) {
        this.navigate_to_delete()
      } else {
        this.$router.push({name: `${this.collection}s`})
      }
    },
    async create_item() {
      this.$v.item.$touch()
      if (this.$v.item.$anyError) {
        return
      }

      this.item.created = new Date()
      this.item.updated = new Date()
      this.item.user = db.collection('user').doc(this.profile.id)
      this.item.uid = this.profile.id
      this.item.team = db.collection('team').doc(this.profile.team.id)

      this.is_saving = true
      if (this.do_before) {
        let success = await this.do_before()
        if (success === false) {
          this.is_saving = false
          return
        }
      }
      let item_doc = this.$firestoreRefs._item
      await item_doc.set(this.item)
      if (this.do_after) {
        let success = await this.do_after()
        if (success === false) {
          this.is_saving = false
          return
        }
      }
      this.is_saving = false

      this.$bvToast.toast(`Data has been saved`, {title: 'Saved', autoHideDelay: 2000, variant: 'success'})

      if (this.navigate_to) {
        this.navigate_to(item_doc.id)
      } else {
        let params = this.params
        params[this.param] = item_doc.id
        this.$router.push({name: this.collection, params: params})
      }
    }
  }
}
